import React, { FC, useState } from 'react';
import GoogleMapReact from 'google-map-react';
import { Coord, DPDPoint, FormType } from "../../types/types";
import { useTranslation } from "react-i18next";
import { GOOGLE_MAP_API_KEY } from "../../data/price";
import RentalPointDetails from "../business/RentalPointDetails";

interface DPDPointSelectorProps{
    points: DPDPoint[],
    chosenPoint: DPDPoint | null,
    center: Coord,
    onPointSelect: (point: DPDPoint) => void,
    formType: FormType
}

const markerPlaceStyle = {
    position: 'absolute',
    transform: 'translate(-50%, -100%)'
}

const DpdPointSelector: FC<DPDPointSelectorProps> = ({points, onPointSelect, center, chosenPoint, formType}) => {
    let defaultProps = {
        center: center,
        zoom: 13
    };
    const [hoveredPoint, setHoveredPoint] = useState<DPDPoint | null>(null);

    return (
        <div className="flex flex-col xl:flex-row">
            <ul className="w-full xl:w-1/3 flex flex-col text-xs pr-3 list-none pl-0">
                {points.map((point) => {
                    return <li onMouseEnter={() => setHoveredPoint(point)}
                               onClick={() => onPointSelect(point)}
                               key={point.id}
                               className="border-gray-400 mb-2">
                        <RentalPointDetails point={point}
                                            hovered={hoveredPoint?.id === point.id}
                                            selected={chosenPoint?.id === point.id}/>
                    </li>
                })}
            </ul>
            <div className="w-full xl:w-8/12 h-72 xl:h-full xl:h-screen">
                <GoogleMapReact
                    bootstrapURLKeys={{key: GOOGLE_MAP_API_KEY, libraries: ['places']}}
                    center={defaultProps.center}
                    defaultZoom={defaultProps.zoom}
                >
                    {points.map((point) => {
                        // @ts-ignore
                        return <div style={markerPlaceStyle} lat={point.lat} lng={point.lng}
                                    onMouseEnter={() => setHoveredPoint(point)}
                                    key={point.id}
                                    onClick={() => onPointSelect(point)}
                        >
                            {hoveredPoint?.id === point.id &&
                                <img src="/assets/dpd-selected.svg" alt="DPD pickup point"/>}
                            {hoveredPoint?.id !== point.id && <img src="/assets/dpd.svg" alt="DPD pickup point"/>}</div>
                    })}
                </GoogleMapReact>
            </div>
        </div>
    );
};

export default DpdPointSelector;
